import React, { useEffect } from 'react'
import LazyLoad from 'react-lazyload'
import { AdBanner } from './adBanner'
import { PromoMessages } from './promoMessages'
import { HeroBanner } from './heroBanner'
import { UpcomingEvents } from './upcomingEvents'
import { CatalogList } from './catalogList'
import { TopSellers } from './topSellers'
import { SingleBanner } from './singleBanner'
import { VideoHero } from './videoHero'
import { CardSection } from './cardSection'
import { SalesReps } from './salesReps'
import { Seals } from "./seals"
import { OlapicList } from './olapicList'
import { Combo } from './combo'

// const AdBanner = React.lazy(() => import("./adBanner"))
// const PromoMessages = React.lazy(() => import("./promoMessages"))
// const HeroBanner = React.lazy(() => import("./heroBanner"))
// const UpcomingEvents = React.lazy(() => import("./upcomingEvents"))
// const CatalogList = React.lazy(() => import("./catalogList"))
// const TopSellers = React.lazy(() => import("./topSellers"))
// const SingleBanner = React.lazy(() => import("./singleBanner"))
// const VideoHero = React.lazy(() => import("./videoHero"))
// const CardSection = React.lazy(() => import("./cardSection"))
// const SalesReps = React.lazy(() => import("./salesReps"))
// const Seals = React.lazy(() => import("./seals"))
// const OlapicList = React.lazy(() => import("./olapicList"))
// const Combo = React.lazy(() => import("./combo"))


export const HomePage = props => {
	const { appData } = props

	const catalogsQty = appData.storedata?.productCatalogs?.length
	const isTryOn = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreTryOn") && appData.storedata?.schoolStoreTryOn?.tryOnBannerUrl)
	const isRingSize = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreRingSizer") && appData.storedata?.schoolStoreRingSizer?.hasRingSizeBanner)
	const isAddBanner = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStorePromotion"))
	const isEvents = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolEvents"))
	const isTopSellers = Boolean(appData.customerdata?.find(data => data.contentType === "ProductTopSellers"))
	const isReps = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreReps"))
	const isOlapic = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreOlapic"))
	const isSeal = Boolean(appData.customerdata?.find(data => data.contentType === "SchoolStoreSeal"))
	const isVideo = Boolean(appData.customerdata?.find(data => data.contentType === "MediaCallout"))
	const isBannerSection = Boolean(appData.customerdata?.find(data => data.contentType === "BannerSection"))

	useEffect(() => {

		// Changing Sitemap for School Store Page
		const setSitemap = setTimeout(()=>{
			const siteMap = document.querySelector('a[href="/site-map"]')
		    siteMap && siteMap.setAttribute('href', '/apps/store/sitemap/-/-/')
		}, 1500)

		// This trick is for Lazy loading, firing 'resize' trigers loading
		window.dispatchEvent(new Event('resize'))

		return ()=>{clearTimeout(setSitemap)}
	}, [])
	
	return (
		<>
		{/* <Suspense fallback={<div>Loading...</div>}> */}
			{isAddBanner && <AdBanner appData={appData}/>}
			<PromoMessages appData={appData} />			
			<HeroBanner appData={appData} />
			
			{isEvents && 
			<LazyLoad offset={100} height={500} once resize>
				<UpcomingEvents appData={appData} />
			</LazyLoad>}

			{ 
				((!isTryOn && !isRingSize) || catalogsQty >= 3 || !catalogsQty) &&
					<LazyLoad offset={100} height={500} once resize>
						<CatalogList appData={appData} />
					</LazyLoad>
			}
			{ 
				((isTryOn || isRingSize) && (catalogsQty === 1 || catalogsQty === 2)) &&
					<LazyLoad offset={100} height={500} once resize>
						<Combo appData={appData} />
					</LazyLoad>
			}

			{isTopSellers && 
			<LazyLoad offset={100} height={500} once resize>
				<TopSellers appData={appData} />
			</LazyLoad>}

			{isBannerSection && 
			<LazyLoad offset={100} height={500} once resize>
				<SingleBanner appData={appData} />
			</LazyLoad>}

			{isVideo &&
			<LazyLoad offset={100} height={500} once resize>
				<VideoHero appData={appData} />
			</LazyLoad>}

			{ 
				((isTryOn || isRingSize) && (catalogsQty === 0 || catalogsQty >= 3)) &&
					<LazyLoad offset={100} height={500} once resize>
						<CardSection appData={appData} />
					</LazyLoad>
			}

			{isReps &&
			<LazyLoad offset={100} height={500} once resize>
				<SalesReps appData={appData} />
			</LazyLoad>}
			
			{isSeal &&
			<LazyLoad offset={100} height={500} once resize>
				<Seals appData={appData} />
			</LazyLoad>}

			{isOlapic && 
			<LazyLoad offset={100} height={500} once resize>
				<OlapicList appData={appData} />
			</LazyLoad>}
		{/* </Suspense> */}
		</>
	)
}
